import React, {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import AtomIcon, {ATOM_ICON_COLORS, ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import IconCarAdd from '@adv-mt/mt-svg-icons/lib/CarAdd'

const EmptyCard = ({baseClass, isSmallSize, onAddVehicle}) => {
  const {i18n} = useContext(Context)
  const CARD_TEXT = i18n.t('COMMON.ADD_VEHICLE')

  const EMPTY_CARD_CLASS = `${baseClass}-emptyCard`
  const EMPTY_CARD_WRAPPER_CLASS = `${EMPTY_CARD_CLASS}Wrapper`
  const EMPTY_CARD_ICON_CLASS = `${EMPTY_CARD_CLASS}Icon`
  const EMPTY_CARD_ICON_BUTTON_CLASS = `${EMPTY_CARD_ICON_CLASS}Button`
  const EMPTY_CARD_TEXT_CLASS = `${EMPTY_CARD_CLASS}Text`

  const {small, large} = ATOM_ICON_SIZES
  const {currentColor} = ATOM_ICON_COLORS

  const iconProps = {
    color: currentColor,
    size: isSmallSize ? small : large
  }

  const _handleAddVehicle = () => onAddVehicle()

  return (
    <div className={EMPTY_CARD_WRAPPER_CLASS}>
      <button className={EMPTY_CARD_ICON_BUTTON_CLASS} onClick={_handleAddVehicle}>
        <AtomIcon {...iconProps}>
          <IconCarAdd />
        </AtomIcon>
      </button>
      <p className={EMPTY_CARD_TEXT_CLASS}>{CARD_TEXT}</p>
    </div>
  )
}

EmptyCard.displayName = 'EmptyCard'
EmptyCard.propTypes = {
  baseClass: PropTypes.string.isRequired,
  isSmallSize: PropTypes.bool,
  onAddVehicle: PropTypes.func.isRequired
}

const MemoEmptyCard = memo(EmptyCard)
MemoEmptyCard.displayName = 'MemoEmptyCard'
export default MemoEmptyCard
